import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loading from '../Loading';

export default function ValidateSession({ children }) {
	const navigate = useNavigate();
	const location = useLocation();
	const { user, loading } = useAuth();

	useEffect(() => {
		// Si no está cargando y no hay usuario autenticado, redirigir al login
		if (!loading && !user) {
			navigate('/', { 
				state: { from: location }, 
				replace: true 
			});
		}
	}, [user, loading, navigate, location]);

	// Mostrar loading mientras se verifica la autenticación
	if (loading) {
		return <Loading />;
	}

	// Si no hay usuario, no mostrar nada (se redirigirá en el useEffect)
	if (!user) {
		return null;
	}

	// Si hay usuario autenticado, mostrar los children
	return <div>{children}</div>;
}
